import { IconChevronRight } from '@tabler/icons-react'

import { AstraIcon, AstraTooltip, getOnlyDate } from '~/astra'
import { useLocationSchedule, usePractitionerSchedule } from '~/storm'

import { DateLocationCell, DatePractitionerCell, isDateLocationCell, isDatePractitionerCell } from '../utils'

type NoteProps = {
    note: string
    openNote: () => void
}

const Note = ({ note, openNote }: NoteProps) => (
    <AstraTooltip tooltipContent="Endre notat">
        <button onClick={openNote} className="pointer-events-auto relative w-full space-y-1 border-b p-2 text-left hover:bg-gray-100">
            <div className="flex">
                <p className="text-center font-medium">Notat</p>
                <AstraIcon icon={IconChevronRight} />
            </div>
            {note.split('\n').map((line, index) => (
                <p key={index}>{line}</p>
            ))}
        </button>
    </AstraTooltip>
)

type PractitionerNotePreviewProps = {
    cell: DatePractitionerCell
    openNote: () => void
}

const PractitionerNotePreview = ({ cell, openNote }: PractitionerNotePreviewProps) => {
    const practitionerSchedule = usePractitionerSchedule({ where: { scheduled_date: getOnlyDate(cell.date), practitioner_id: cell.practitionerId } })

    if (!practitionerSchedule?.comment) return null

    return <Note note={practitionerSchedule.comment} openNote={openNote} />
}

type LocationNotePreviewProps = {
    cell: DateLocationCell
    openNote: () => void
}

const LocationNotePreview = ({ cell, openNote }: LocationNotePreviewProps) => {
    const locationSchedule = useLocationSchedule({ where: { scheduled_date: getOnlyDate(cell.date), location_id: cell.locationId } })

    if (!locationSchedule?.comment) return null

    return <Note note={locationSchedule.comment} openNote={openNote} />
}

type Props = {
    cell: DatePractitionerCell | DateLocationCell
    openNote: () => void
}

export const NotePreview = ({ cell, openNote }: Props) => {
    if (isDatePractitionerCell(cell)) {
        return <PractitionerNotePreview cell={cell} openNote={openNote} />
    }

    if (isDateLocationCell(cell)) {
        return <LocationNotePreview cell={cell} openNote={openNote} />
    }

    return null
}
